import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
export const Migrate = (props) => {
    let location = useLocation();
    const redirectPath = location.pathname.replace('/comp/', '/event/');
    return React.createElement(Navigate, { to: redirectPath, replace: true });
};
